import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'cloudinary-ui', {
    deleteScreenshot: 'Delete screenshot',
    deleteScreenshotConfirmTitle: 'Delete screenshot?',
    deleteScreenshotConfirmDescription:
      'This will permanently delete the screenshot from Cloudinary.',
    screenshotDeleted: 'Screenshot deleted',
    deleteScreenshotFailed: 'Failed to delete image',
    deleteScreenshotException: 'Failed to delete screenshot',
    uploadScreenshots: 'Upload screenshots',
    cloudinaryScriptNotLoaded: 'Cloudinary script not loaded',
    cloudinaryNotSignedIn: 'Sign in before uploading an image',
    cloudinaryUploadError: 'Cloudinary upload error',
  });
}
